import { create } from 'zustand'

interface AppStore {
  prevPage: string | null
  setPrevPage: (prevPage: string | null) => void
  showBackButton: boolean
  setShowBackButton: (showBackButton: boolean) => void
}

export const useAppStore = create<AppStore>(set => ({
  prevPage: null,
  setPrevPage: (prevPage: string | null) => {
    set({ prevPage })
  },
  showBackButton: false,
  setShowBackButton: (showBackButton: boolean) => {
    set({ showBackButton })
  },
}))
